import { REGEX } from "constants/validate";
import dayjs from "dayjs";

const formatCurrency = (value: number, suffix: string = ""): string => {
  if (value === 0) return "0";
  if (!value) return "";
  const formattedValue = value.toLocaleString();
  return `${formattedValue}${suffix}`;
};

const formatDate = (date: string) => {
  const d = new Date(date);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}/${mm}/${dd}`;
};

const formatDateTime = (date: string) => {
  if (!date) return "";
  // const UTC_JAPAN = 9;
  const d = new Date(date);

  d.setHours(d.getHours()); // + UTC_JAPAN

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mi = String(d.getMinutes()).padStart(2, "0");
  return `${yyyy}/${mm}/${dd} ${hh}:${mi}`;
};

// Function to format phone number for C0001 user type
const formatPhoneNumber = (phoneNumber: string, userType: string | null): string => {
  if (userType === "C0001" && phoneNumber && phoneNumber.length >= 4) {
    // Hide last 4 digits with asterisks
    const visiblePart = phoneNumber.slice(0, -4);
    return `${visiblePart}****`;
  }
  return phoneNumber;
};

const getCurrentTimeUtcString = (formatType: string = "YYYY/MM/DD hh:mm:ss"): string =>
  dayjs().utc().format(formatType);

const restrictDecimalInput = (value: string, limit: number, isBlur: boolean = false): string => {
  let cleanedValue = value.replace(/[^0-9.]/g, "");

  const decimalParts = cleanedValue.split(".");
  if (decimalParts.length > 1) {
    decimalParts[1] = decimalParts[1].slice(0, limit);
    cleanedValue = decimalParts.join(".");
  }

  cleanedValue = cleanedValue.replace(/\.(?=.*\.)/g, "");

  if (isBlur) {
    const parts = cleanedValue.split(".");
    parts[0] = parts[0].replace(/^0+/, "") || "0";
    cleanedValue = parts.join(".");
    if (cleanedValue === "0." || cleanedValue === ".") {
      return "0";
    }
  }

  return cleanedValue;
};

const passwordValidator = (password: string): boolean =>
  REGEX.HALFWIDTH.test(password) && password.length >= 8;

const filterFullwidthText = (inputText: string): string =>
  inputText.replace(/[^\uFF01-\uFF60\uFFE0-\uFFE6\u3000-\u303F]/g, "");

const isHalfwidthNumber = (input: number) => /^[0-9]+$/.test(input.toString());

/** Check if value is a price label (currency format, "-", "0", or "無料") to prefix with ¥ */
const isPriceLabel = (value: unknown): boolean => {
  if (typeof value !== "string") return false;
  return value === "-" || value === "0" || value === "無料" || /^[\d,]+$/.test(value);
};

const getPriceDisplayText = (
  wheelDiscountedSalePrice: number,
  tireDiscountedSalePrice: number,
): { text: string } => {
  const wheelPrice = wheelDiscountedSalePrice / 4;
  const tirePrice = tireDiscountedSalePrice / 4;

  const tireIsInteger = Number.isInteger(tirePrice);
  const wheelIsInteger = Number.isInteger(wheelPrice);

  if (tireIsInteger && wheelIsInteger) {
    return { text: `1本 : T ${formatCurrency(tirePrice)}  W ${formatCurrency(wheelPrice)}` };
  }

  if (tireIsInteger && !wheelIsInteger) {
    const flooredWheel = Math.floor(wheelPrice);
    return { text: `1本 : T ${formatCurrency(tirePrice)}  W ${formatCurrency(flooredWheel)}` };
  }

  return { text: "セット販売でレジ登録してください" };
} 


export { formatWheelRimDiamDisplay, parseWheelRimDiam } from "./wheelRimDiam";

export {
  formatCurrency,
  formatDate,
  formatDateTime,
  formatPhoneNumber,
  getCurrentTimeUtcString,
  passwordValidator,
  filterFullwidthText,
  isHalfwidthNumber,
  isPriceLabel,
  restrictDecimalInput,
  getPriceDisplayText,
};
